import { GNO } from '../types';
export default {
  type: GNO,
  service: 'gnosischain.com-ws',
  url: 'wss://gnosis-rpc.publicnode.com',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
